import React from 'react';
import type { ReactNode } from 'react';
import { useCssHandles } from '../../../utils/functions';

const SELLERS_CSS_HANDLES = ['sellerRow'] as const;

interface Props {
	children: ReactNode;
	componentId?: string;
	blockClass?: string;
}

function SellerRow({ children, componentId, blockClass }: Props) {
	const { handles }: any = useCssHandles(`vtex-seller-selector-0-x`, SELLERS_CSS_HANDLES, blockClass);

	return (
		<div
			data-selection={componentId}
			className={`${handles.sellerRow} justify-between-s bt-0-m b--solid-s bw1 b--muted-3 flex br--bottom items-center-s flex-column-s flex-row-m`}
		>
			{children}
		</div>
	);
}

export default SellerRow;
